<template>
	<div class="flex h-24 md:h-28 border-b border-gray-500">
		<DraftStatus />
		<div
			v-for="(data, id) in picked_players"
			:key="id"
			class="player-card self-center"
		>
			<div class="player-name">{{ data.player.name }}</div>
			<div class="player-team">
				{{ data.user.name }}
			</div>
		</div>
		<div
			class="w-full h-full items-center flex justify-center bg-gray-100 pl-5"
			v-if="Object.keys(picked_players).length === 0"
		>
			No picks have been made yet
		</div>
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import DraftStatus from './user/DraftStatus';

export default {
	computed: {
		...mapGetters(['picked_players', 'user_name', 'hasDraftStarted']),
		...mapState(['current_picker', 'current_round']),
	},
	components: { DraftStatus },
};
</script>

<style scoped>
.player-card {
	@apply ml-3 my-2;
}

.player-team {
	@apply text-xs;
}
</style>
